export default __webpack_public_path__ + "static/media/dashboard-bulk-transaction-icon-light.a9750191.svg";